export const formatBanner = (item: IResponsePosterContent): IModelPoster => {
  return {
    imageUrl: item.url,
    linkUrl: item.targetUrl,
    linkTarget: item.target,
  };
};

export const formatIdentity = (item: IResponseIdentity): IModelIdentity => {
  const banners = item.extendedContent?.PosterF?.map(formatBanner) || [];
  const logoUrl = item.extendedContent?.PosterH?.[0]?.url || "";

  return {
    id: item._id,
    archived: item.archived,
    title: item.title || "NO TITLE",
    bannerUrl: item.content?.PosterF || "",
    banners,
    imageUrl: item.content?.PosterH || "",
    logoUrl,
  };
};

export const formatIdentityItem = (item: IResponseIdentityItem): IModelIdentityItem => {
  const banners = item.extendedContent?.PosterF?.map(formatBanner) || [];
  const logoUrl = item.extendedContent?.PosterH?.[0]?.url || "";

  return {
    id: item._id,
    archived: item.archived,
    title: item.title || "NO TITLE",
    imageUrl: item.content?.PosterH || "",
    bannerUrl: item.content?.PosterF,
    identityIds: item.identityId || [],
    facebookUrl: item.socialMediasLinks?.facebook,
    instagramUrl: item.socialMediasLinks?.instagram,
    xUrl: item.socialMediasLinks?.twitter,
    webUrl: item.socialMediasLinks?.web,
    banners,
    logoUrl,
  };
};

export const formatEventSubCategory = (item: IResponseIdentityItem): IModelIdentityItem => ({
  id: item._id,
  title: item.title || "NO TITLE",
  imageUrl: item.content?.PosterH || "",
  bannerUrl: item.content?.PosterF,
  identityIds: item.mediaParentIdentities ? item.mediaParentIdentities.map(formatIdentity) : [],
});

export const formatClubList = (categories: IResponseСlubList[]): IModelFavoriteClub[] => {
  const clubList = categories.reduce((result, category) => {
    const subCategories = category.relatedIdentityItems.map(subCategory => ({
      id: `${category._id}|${subCategory._id}`,
      label: subCategory.title,
      categoryTitle: category.title,
    }));
    return [...result, ...subCategories];
  }, [] as IModelFavoriteClub[]);

  return clubList;
};

export const getFavoriteClubIdFromList = (list: IResponseProfileClubList): string | null => {
  if (!list)
    return null;

  const [[key, [value]]] = Object.entries(list);

  return `${key}|${value}`;
};
